module.exports = __webpack_public_path__ + "images/檀程长图_02.jpg?v=a053c5fe";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan4/檀程长图_02.jpg
 ** module id = 188
 ** module chunks = 1 2
 **/